var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerGreySlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98066 1V7.99898M13.574 4.24753C14.4828 5.12855 15.1017 6.25094 15.3523 7.47279C15.6029 8.69463 15.4741 9.96106 14.9821 11.1119C14.49 12.2628 13.6569 13.2465 12.588 13.9386C11.5192 14.6306 10.2625 15 8.97705 15C7.69156 15 6.43494 14.6306 5.36607 13.9386C4.29719 13.2465 3.46407 12.2628 2.97204 11.1119C2.48001 9.96106 2.35116 8.69463 2.60179 7.47279C2.85243 6.25094 3.47128 5.12855 4.38011 4.24753",
    stroke: "#BEBDBD",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3308 14.1361C14.6027 14.2918 14.9298 14.3713 15.2423 14.2824C15.5838 14.1852 15.819 13.9094 15.8775 13.5547C15.9311 13.2306 15.8303 12.9099 15.6856 12.6595C15.5373 12.4028 15.3127 12.1656 15.0364 12.0072L2.34348 4.73225C2.07167 4.57646 1.74458 4.49696 1.43206 4.58592C1.09053 4.68314 0.855377 4.95891 0.796782 5.31364C0.74325 5.63772 0.844035 5.95842 0.988715 6.2088C1.13705 6.46552 1.36162 6.70275 1.63788 6.86108L14.3308 14.1361Z",
    fill: "#BEBDBD",
    stroke: "#FBFBFB",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerGreySlash);
export default __webpack_public_path__ + "static/media/power_grey_slash.39b452ae7f1b1fd0d6201d75d72696fd.svg";
export { ForwardRef as ReactComponent };